module.exports = __webpack_public_path__ + "static/media/otica.70cd4c76.png";